import { Injectable, inject } from '@angular/core';
import {
  IFirmwareCliente,
  IListado,
  ICrearFirmwareCliente,
  IQueryParam,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class FirmwareClientesService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<IFirmwareCliente>> {
    let params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/firmwareClientes`, { params });
  }

  public listarPorId(id: string): Observable<IFirmwareCliente> {
    return this.http.get(`/firmwareClientes/${id}`);
  }

  public crear(dato: ICrearFirmwareCliente): Observable<IFirmwareCliente> {
    return this.http.post(`/firmwareClientes`, dato);
  }

  public eliminar(id: string): Observable<IFirmwareCliente> {
    return this.http.delete(`/firmwareClientes/${id}`);
  }
}
